<template>
  <span id="day-of-service-detail">
        <i class="el-icon-search header-info-dialog-value icon-action" id="btn-day-of-service-detail"
            @click="dialogVisible = true" size="mini" icon="el-icon-plus"></i>
    <el-dialog
        id="charge-code-detail-dialog"
        :visible.sync="dialogVisible"
        width="70%"
        :title="$t('tariff.chargeCodes.informationTitle')"
        :close-on-click-modal="false"
        append-to-body
    >
      <el-row>
        <el-col :span="6">
            <label class="span-small-list dos-label">{{ $t('tariff.chargeCodes.name') }}</label>
            <span class="span-small-list">{{ chargeCode.name }}</span>
          </el-col>

          <el-col :span="6">
            <label class="span-small-list dos-label">{{ $t('tariff.chargeCodes.code') }}</label>
            <span class="span-small-list">{{ chargeCode.code }}</span>
          </el-col>

          <el-col :span="6">
            <label class="span-small-list dos-label">{{ $t('tariff.chargeCodes.type') }}</label>
            <span class="span-small-list">{{ getChargeCodeType(chargeCode.chargeType) }}</span>
          </el-col>

      </el-row>

      <el-row>
        <el-col :span="6">
            <label class="span-small-list dos-label">{{ $t('tariff.chargeCodes.revenueCharge') }}</label>
            <span class="span-small-list">{{ getBooleanLabel(chargeCode.revenueCharge) }}</span>
          </el-col>

          <el-col :span="6">
            <label class="span-small-list dos-label">{{ $t('tariff.chargeCodes.priority') }}</label>
            <span class="span-small-list">{{ chargeCode.priority }}</span>
          </el-col>

          <el-col :span="6">
            <label class="span-small-list dos-label">{{ $t('tariff.chargeCodes.management.status') }}</label>
            <span class="span-small-list">{{ getChargeCodeStatus(chargeCode.status) }}</span>
          </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
            <span class="title-list">{{ $t('tariff.chargeCodes.sageIntacctTitle') }}</span>
          </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
            <label class="span-small-list dos-label">{{ $t('tariff.chargeCodes.sageAccount') }}</label>
            <span class="span-small-list">{{ chargeCode.sageAccount }}</span>
          </el-col>

          <el-col :span="6">
            <label class="span-small-list dos-label">{{ $t('tariff.chargeCodes.department') }}</label>
            <span class="span-small-list">{{ chargeCode.department }}</span>
          </el-col>

          <el-col :span="6">
            <label class="span-small-list dos-label">{{ $t('tariff.chargeCodes.location') }}</label>
            <span class="span-small-list">{{ chargeCode.location }}</span>
          </el-col>
      </el-row>

      <el-row>
        <el-col :span="24">
            <span class="title-list">{{ $t('tariff.chargeCodes.management.additionalInformation') }}</span>
          </el-col>
      </el-row>
      <el-row>
      <el-col :span="6">
            <label class="span-small-list dos-label">{{ $t('tariff.chargeCodes.management.createdBy') }}</label>
            <span class="span-small-list">{{ defaultWhenEmpty(chargeCode.createdByUsername) }}</span>
          </el-col>

          <el-col :span="6">
            <label class="span-small-list dos-label">{{ $t('tariff.chargeCodes.management.createdTime') }}</label>
            <span class="span-small-list">{{ defaultDateWhenEmpty(chargeCode.auditCreationDate) }}</span>
          </el-col>

          <el-col :span="6">
            <label class="span-small-list dos-label">{{ $t('tariff.chargeCodes.management.lastModifiedBy') }}</label>
            <span class="span-small-list">{{ defaultWhenEmpty(chargeCode.lastUpdatedByUsername) }}</span>
          </el-col>

          <el-col :span="6">
            <label class="span-small-list dos-label">{{ $t('tariff.chargeCodes.management.lastModificationDate') }}</label>
            <span class="span-small-list">{{ defaultDateWhenEmpty(chargeCode.auditLastUpdate) }}</span>
          </el-col>


      </el-row>

  </el-dialog>


    </span>
</template>

<script>
// import constants from '@/utils/constants';

export default {
  name: 'DetailChargeCode',
  props: {
    chargeCode: {
      type: Object,
      require: true
    }
  },
  data() {
    return {
      dialogVisible: false,
    };
  },
  methods: {
    getChargeCodeType(recrdType) {
      // eslint-disable-next-line eqeqeq
      return recrdType; // constants.CHARGE_CODE.CHARGE_CODE_TYPES.find(ct => ct.value == recrdType).label;
    },
    getBooleanLabel(booleanValue) {
      return booleanValue ? 'Yes' : 'No';
    },
    defaultWhenEmpty(value) {
      return value || '-';
    },
    defaultDateWhenEmpty(value) {
      if (!value) return '-';
      const date = new Date(value);

      if (isNaN(date.getTime())) return '-';

      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hour = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');

      return `${month}/${day}/${year} ${hour}:${minutes}`;
    },
    getChargeCodeStatus(status) {
      return status ? this.$t('tariff.chargeCodes.active') : this.$t('tariff.chargeCodes.inactive');
    },
  }
};
</script>
